module.exports = __webpack_public_path__ + "static/media/tealCTAAccent.e5007dac.svg";